module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBold.c9e437c1.ttf";